import React,{Component} from 'react'
import {Container, Table, Button, ButtonToolbar} from 'react-bootstrap'
import {DriveModal} from './DriveModal'
import { ToId, ToDate } from '../../../components/Shared/ViewControl'
import {meResults} from '../../../components/Shared/meLayout'
import Header from '../../Header'

export class Drive extends Component{

    constructor (props){
        super(props)
        this.state = {items:[], itemId:0, modalShow:false, mode:0, search:''}
        this.route='sync/drive'
        this.entity='Drives'
        this.istyle = {display: 'flex', justifyContent: 'center'}
        this.resizer = new  meResults(this.entity)
        //console.log('Drive.global',this.props.global)
    }

    componentDidMount(){
        this.Load()
    }

    componentDidUpdate() {
        document.title = `Drive ${this.state.itemId}`;
    }

    componentWillUnmount() {
        this.setState({items:[]})        
        //document.removeEventListener("click", this.closeMenu);
    }

    Load() {
        this.props.global.GET(this.route)
        .then(data => {
            this.setState({items:data})
            this.resizer.selectorAll()
        })
        .catch(error => console.log({ error }))
    }    
    
    Delete(id) {
        this.props.global.DELETE(this.route, id)
        .then(()=> this.Load())
    }

    modalClose =() => {
        this.setState({modalShow:false})
        this.Load()
    }

    onSearch = (value) => {
        this.setState({search:value})
        this.forceUpdate();
    }

    render() {

        const {items}=this.state;

        const filtered = items.filter(
                (item)=>{
                return (item.Name+item.Path+item.Pattern).indexOf(this.state.search)!==-1;
        })

        return (
            <Container>
        <Header lang={this.props.lang} service={'Synchronize'} account={this.props.account} onSearch={this.onSearch} />
            
<Table className="mt-3" striped hover bordered size="sm">
<thead id={this.entity+"Head"}
            onMouseDown={e=>this.resizer.mouseDown(e)} 
            onMouseMove={e=>this.resizer.mouseMove(e)} 
            onMouseUp={e=>this.resizer.mouseUp(e)}     
>

    <tr>
        <th>Id</th>
        <th>Site</th>
        <th>Name</th>
        <th>Path</th>
        <th>Pattern</th>
        <th>Ignore</th>
        <th style={{width:'6rem'}}>Date</th>
        <th>
            <ButtonToolbar style={{ display: 'flex', justifyContent: 'center', width:'7em' }}>
            <Button variant='primary' onClick={()=>this.setState({modalShow:true, itemId:0, mode:2})}>
            +</Button>           
            </ButtonToolbar>
        </th> 
    </tr>
</thead>

<tbody>
    {
        filtered.map(item=>
            <tr key={item.Id}>
<ToId value={item.Id} onClick={()=> this.setState({modalShow:true,itemId:item.Id,mode:0})} selelcetd={this.state.itemId}/>
<td>{item.SiteId}</td>
<td>{item.Name}</td>
<td title={item.Path}>{item.Path.substring(item.Path.length - 24)}</td>
<td>{item.Pattern}</td>
<td title={item.Ignore}>{item.Ignore.substring(0,item.Ignore.length - 16)}</td>
<ToDate value={item.Updated} />
<td style={{width:'2rem'}}>
    <ButtonToolbar style={this.istyle}>
        <Button className="mr-2" variant="info" onClick={()=> this.setState({modalShow:true,itemId:item.Id,mode:1})}
        ><i className="fa fa-edit" style={this.istyle}></i></Button>

        <Button className="mr-2" variant="danger" onClick={()=> this.Delete(item.Id)} 
        ><i className="fa fa-trash" style={this.istyle}></i></Button>
    </ButtonToolbar>
</td>
            </tr>
            )
    }
</tbody>
</Table>

{this.state.modalShow ?

<DriveModal 
    global={this.props.global}
    entity={this.route}
    id={this.state.itemId}
    mode={this.state.mode}
    show={true}
    onHide={this.modalClose}
/>
: null}

</Container>


        )
    }
}